import { HTMLProps, memo, SVGAttributes, useContext } from 'preact/compat';
import { decimal, isNone, isSome, maybe, resourceLink } from '../../common/util.js';
import { SiteContext } from '../context.js';
import { IconName } from '../../common/data/icons.js';
import { getFallbackContext, getSiteContext } from '../templates/site.js';
import { Decimal, Maybe } from '../../common/data.js';
import { ClassNameArray, classNames } from '../lib/util.js';

export type IconProps = Omit<SVGAttributes, 'ref' | 'name'>;

export const Icon = memo(({ name, title, alt, ...props }: { name: IconName, classes?: Maybe<ClassNameArray>; checked?: Maybe<boolean>; alt?: Maybe<string> } & IconProps) => {
	const sc = useContext(SiteContext);
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	const c = sc?.context?.value ?? getSiteContext()?.context?.value ?? getFallbackContext();
	const svg = resourceLink(c, 'icons.svg');
	const titleStr = title ?? alt ?? undefined;
	return <><svg
		{...props}
		class={undefined}
		className={classNames(
			'icon',
			`--${name}`,
			props.checked && '--checked',
			...props.classes ?? [],
			props.className as Maybe<string>,
			props.class as Maybe<string>
		)}
		viewBox="0 0 100 100"
		width="25"
		height="25"
		aria-label={titleStr}
		aria-hidden={!titleStr}
	>
		{maybe(titleStr, t => <title>{t}</title>)}
		<use href={`${svg}#${name}`} x="0" y="0" width="100" height="100" />
	</svg>{' '}</>;
});

export const StarBar = ({ rating, ...props }: {
	rating: Maybe<Decimal>;
} & Omit<HTMLProps<HTMLDivElement>, 'ref'>) => {
	return <div
		className={classNames('rating-stars', isNone(rating) && '--null')} {...props}
		title={isSome(rating) ? `${decimal(rating)} out of 5` : 'Not rated'}
		style={{ '--rating-value': decimal(rating ?? 0) }}
	/>;
};
